export default "__VITE_ASSET__ONVEYN69__"